// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const listImportClientsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
});

export const listImportClientsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of clients
 */
export const listImportClients200Schema = z.array(z.object({}));

/**
 * @description Unprocessable Entity - Integration connection error
 */
export const listImportClients422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const listImportClientsQueryResponseSchema = z.lazy(() => listImportClients200Schema);
